import * as React from "react";

export const SvgLogout = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M4.167 18.334h5a.834.834 0 0 0 0-1.667h-5a.833.833 0 0 1-.834-.833V4.167a.833.833 0 0 1 .834-.833h5a.833.833 0 0 0 0-1.667h-5a2.5 2.5 0 0 0-2.5 2.5v11.667a2.5 2.5 0 0 0 2.5 2.5Z"
			fill={props.color ?? "#A8A8A8"}
		/>
		<path
			d="M13.58 7.256a.832.832 0 0 1 .585-1.433.833.833 0 0 1 .593.255L18.09 9.41a.833.833 0 0 1 0 1.178l-3.333 3.334a.833.833 0 1 1-1.179-1.178l1.911-1.911H5.835a.833.833 0 1 1 0-1.667h9.655l-1.91-1.91Z"
			fill={props.color ?? "#A8A8A8"}
		/>
	</svg>
);
